import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { MessageTitle } from 'src/app/messages/interfaces/MessageTitle';
import { MessagesState } from 'src/app/messages/_services/messages.state';
import { MessagesFacade } from 'src/app/messages/_services/messages.facade';

@Component({
  selector: 'app-message-title',
  templateUrl: './message-title.component.html',
  styleUrls: ['./message-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageTitleComponent implements OnInit {

  @Input() messageTitle:MessageTitle;
  currentMessageId:number;

  constructor(private messageFacade: MessagesFacade) { }

  ngOnInit(): void {
    this.messageFacade.getCurrentMessage$().subscribe(message=>{
      this.currentMessageId = message[0]?.id
    })
  }
  messageClicked(){
    this.messageFacade.setMessageById(this.messageTitle.id);
  
  }

}
